import React, { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { useLocalization } from 'gatsby-theme-i18n'
import { pointerDictionary } from './pointerDictionary'

const MousePointer = () => {
  const { locale } = useLocalization()
  const cursorRef = useRef(null)
  const [cursorVisible, setCursorVisible] = useState(false)
  const [hoveredButton, setHoveredButton] = useState(null)

  useEffect(() => {
    const cursor = cursorRef.current

    const storedMouseX = localStorage.getItem('mouseX')
    const storedMouseY = localStorage.getItem('mouseY')

    if (storedMouseX && storedMouseY) {
      gsap.set(cursor, {
        x: storedMouseX,
        y: storedMouseY,
        onComplete: () => {
          setCursorVisible(true)
        }
      })
    } else {
      setCursorVisible(true)
    }

    const updateCursorPosition = (event) => {
      const { clientX, clientY } = event
      const mouseX = clientX - cursor.clientWidth / 2
      const mouseY = clientY - cursor.clientHeight / 2

      gsap.to(cursor, {
        x: mouseX,
        y: mouseY,
        duration: 0.1,
        ease: 'power2.out'
      })

      localStorage.setItem('mouseX', mouseX)
      localStorage.setItem('mouseY', mouseY)

      const buttonClasses = ['openBtn', 'prevBtn', 'nextBtn']
      const hoveredButton = buttonClasses.find((className) =>
        event.target.classList.contains(className)
      )
      setHoveredButton(hoveredButton)
    }

    document.addEventListener('mousemove', updateCursorPosition)

    return () => {
      document.removeEventListener('mousemove', updateCursorPosition)
    }
  }, [])

  useEffect(() => {
    const cursor = cursorRef.current

    if (hoveredButton) {
      gsap.to(cursor, {
        width: '100px',
        height: '100px',
        duration: 0.3,
        ease: 'power2.out'
      })
    } else {
      gsap.to(cursor, {
        width: '15px',
        height: '15px',
        duration: 0.3,
        ease: 'power2.out'
      })
    }
  }, [hoveredButton])

  const getTextForButton = () => {
    switch (hoveredButton) {
      case 'openBtn':
        return pointerDictionary.openBtn[locale]
      case 'prevBtn':
        return pointerDictionary.prevBtn[locale]
      case 'nextBtn':
        return pointerDictionary.nextBtn[locale]
      default:
        return ''
    }
  }

  const buttonText = getTextForButton()

  return (
    <div className={`z-50 fixed ${cursorVisible ? 'visible' : 'hidden'}`}>
      <div
        className={`bg-brand-primary pointer-events-none sm:block hidden overflow-hidden rounded-full`}
        ref={cursorRef}
      >
        {hoveredButton && buttonText && (
          <div className='flex justify-center items-center h-full'>
            <div className='text-2xl font-normal'>{buttonText}</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default MousePointer
